module.exports = __webpack_public_path__ + "img/113.88948b78.webp";